// extracted by mini-css-extract-plugin
export var adjacentSlide = "_sr-9";
export var arrowButtonContainer = "_sr-5";
export var arrowButtonIcon = "_sr-6";
export var carouselArrowButton = "_sr-2";
export var carouselElementContainer = "_sr-1";
export var currentSlide = "_sr-8";
export var left = "_sr-3";
export var otherSlide = "_sr-a";
export var productCarouselContainer = "_sr-0";
export var right = "_sr-4";
export var sliderOverflow = "_sr-7";